var _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.2V6.3V18.9C0 20.0581 1.0465 21 2.33333 21H18.6667C19.9535 21 21 20.0581 21 18.9V6.3V4.2C21 3.04185 19.9535 2.1 18.6667 2.1H16.3333V0H14V2.1H7V0H4.66667V2.1H2.33333C1.0465 2.1 0 3.04185 0 4.2ZM18.669 18.8999H2.33333V6.29989H18.6667L18.669 18.8999Z",
    fill: "url(#paint0_linear_765_7409)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.2V6.3V18.9C0 20.0581 1.0465 21 2.33333 21H18.6667C19.9535 21 21 20.0581 21 18.9V6.3V4.2C21 3.04185 19.9535 2.1 18.6667 2.1H16.3333V0H14V2.1H7V0H4.66667V2.1H2.33333C1.0465 2.1 0 3.04185 0 4.2ZM18.669 18.8999H2.33333V6.29989H18.6667L18.669 18.8999Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_765_7409",
    x1: 0,
    y1: 10.7561,
    x2: 21,
    y2: 10.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FDDF5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.98de6bcab790685716aa4bbdfb102d51.svg";
export { ForwardRef as ReactComponent };